import React, {PureComponent} from 'react'
import {Button, message, Upload} from '@ss/mtd-react';
import propTypes from 'prop-types';
import {
    formatFileSize,
    generateId,
    getFileExtension,
    getFilePreviewUrl,
    getFileSize,
    shouldSliceUpload,
    UploadSourceType,
} from "@/utils/uploadSdk"
import uploadSdk from '@/pages/UploadManagement/utils/uploadSdk'
import {fetchData} from "@/utils";
import urls from "@/urls";

class UploadFile extends PureComponent {
    constructor(props) {
        super(props);
    }

    validateFileSize = (file) => {
        const { maxSizeLimit } = this.props;
        const fileSize = getFileSize(file, maxSizeLimit.unit);
        return fileSize <= maxSizeLimit.size
    }

    generateImageId = (baseLength = 37, digitWeight = 3)=> {
        // 定义基础字符集
        const letters = 'abcdefghijklmnopqrstuvwxyz';
        const digits = '0123456789';

        // 根据数字权重生成最终的字符集
        const chars = letters + digits.repeat(digitWeight);

        // 确定ID的最终长度，介于37到40位之间
        const finalLength = baseLength + Math.floor(Math.random() * 4);

        // 使用Web Crypto API生成随机数
        const randomBuffer = new Uint8Array(finalLength);
        window.crypto.getRandomValues(randomBuffer);

        // 根据随机数和字符集生成ID
        let id = '';
        randomBuffer.forEach((byte) => {
            const index = byte % chars.length; // 确保索引不会超出字符集的范围
            id += chars[index];
        });

        return id;
    }


    handleBefore = (files) => {
        const { maxLength, maxSizeLimit } = this.props;
        if (files.length > maxLength) {
            message.error({
                message: `上传文件数量超过${maxLength}，请重新上传！`
            });
            return false;
        }
        const overSizeState = files.every(item => {
            return !this.validateFileSize(item)
        })
        if (overSizeState) {
            message.error({
                message: `上传失败，请上传${maxSizeLimit.size}${maxSizeLimit.unit}以下的文件`
            });
            return false
        }
    }

    handleUpload = async (file) => {

        // 检查文件是否超过大小
        const overSizeState = !this.validateFileSize(file);
        const { maxSizeLimit } = this.props;
        if (overSizeState) {
            message.error({
                message: `上传${file.name}失败，请上传${maxSizeLimit.size}${maxSizeLimit.unit}以下的文件`
            });
            return
        }
        // 判断文件是否需要分片上传
        const sliceObj = shouldSliceUpload(file);
        const uploadfile = {
            fileCode: generateId(),
            fileName: file.name,
            fileSourceType: UploadSourceType.FILE,
            fileType: file.type,
            fileSize: file.size,
            fileSizeSpc: formatFileSize(file.size),
            fileExtension: getFileExtension(file.type, file.name),
            filePreviewUrl: getFilePreviewUrl(file.type, file.name),
            hasError: false,
            hasUploaded: false,
            percent: 0,
            fileUrl: '',
            shouldSliceUpload: sliceObj.sliceState,
            uploadInstance: null
        }
        const randomImgId = this.generateImageId();
        const uploadInstance = uploadSdk.initVenusUploadInstance({
            files: [file],
            queryParams:{
                filename:`${randomImgId}.${getFileExtension(file.type, file.name)}`
            },
            onProgress: (percent) => {
                //上传进度回调
                uploadfile.percent = percent;
                uploadfile.hasError = false;
                const { changeFileStatus } = this.props;
                changeFileStatus(uploadfile);
            },
            onFinish: async (fileInfos) => {
                const files = fileInfos[0];
                console.log("上传完成", files)
                if (files.status === 'success') {
                    // 清除mss临时资源
                    fetchData(urls.image.addImageToCleanDB,{
                        fileKey: files.fileKey,
                        filePath:files.originalLink,
                        originalFileName:files.originalFileName,
                        size:files.file.size
                    })
                    console.timeEnd(`${uploadfile.fileName}`);
                    uploadfile.fileUrl = files.originalLink;
                    const { onSuccess } = this.props;
                    console.log("上传成功:", files.originalLink)
                    onSuccess(uploadfile)
                } else {
                    message.error({
                        message: "Image upload failed, please upload again"
                    });
                }
                //如果是源文件，直接选中
                console.timeEnd('uploadFile')
            },
            onError: (err) => {
                console.log('err is ->', err)
                message.error({
                    message: `The ${uploadfile.fileName} upload failed. Please re-upload`
                });
                uploadfile.hasError = true;
                const { onError, changeFileStatus } = this.props
                if (onError) {
                    onError(uploadfile)
                } else {
                    changeFileStatus(uploadfile)
                }

            }
        });
        await uploadInstance.upload();
    };

    render() {
        const { accept, children, multiple, style, draggable } = this.props;
        return (
            <Upload
                className="upload-img-demo"
                draggable={draggable}
                multiple={multiple}
                accept={accept}
                onBeforeUpload={this.handleBefore}
                onUpload={this.handleUpload.bind(this)}
                style={style}
            >
                {
                    children || <Button type="primary">点击上传文件</Button>
                }
            </Upload>
        )
    }
}

UploadFile.propTypes = {
    isImage: propTypes.bool,
    isVideo: propTypes.bool,
    style: propTypes.object,
    draggable: propTypes.bool,
    multiple: propTypes.bool,
    maxLength: propTypes.number,
    maxSizeLimit: propTypes.object,
    accept: propTypes.string,
    children: propTypes.node,
    addUploadFile: propTypes.func,
    changeFileStatus: propTypes.func,
    onSuccess: propTypes.func,
    onError: propTypes.func
};
UploadFile.defaultProps = {
    isVideo: false,
    isImage: false,
    style: {},
    draggable: true,
    multiple: true,
    maxLength: 20,
    maxSizeLimit: {
        size: 50,
        unit: 'MB'
    },
    accept: ''
};

export default UploadFile;
